import React, { useState, useEffect } from "react";
import Footer from "../../components/Footer/Footer";
import Header from "../../components/Header/Header";
import Logout from "./Logout";
import Sidebar from "./Sidebar";
import "../../assets/css/return.css";
import "../../assets/css/Myorder.css";
import AuthHeader from "../../components/AuthHeader/AuthHeader";

const Myorder = () => {
	function orderdetail() {
		window.location.href = "/Myorder-detail";
	}
	return (
		<>
			<AuthHeader />
			{/* My adresses starts here */}
			<section className="my-profile">
				<div className="container">
					<div className="row">
						<div className="col-lg-3">
							<Sidebar />
						</div>
						<div className="col-lg-9">
							<Logout />
							{/* return payment starts here */}
							<div className="return-request-wrapper">
								<div className="return-heading-wrapper">
									<h3>My Orders</h3>
								</div>
								<div className="return-table-wrapper">
									<div className="table-responsive">
										<table className="table">
											<thead>
												<tr>
													<th className="Order-h">OrderNo</th>
													<th className="Date-h">Order Date</th>
													<th className="Return-h">Status</th>
													<th className="Payment-h">Payment Status</th>
													<th className="Total-h">Total</th>
													<th className="detail-h"></th>
												</tr>
											</thead>
											<tbody>
												<tr>
													<td className="order-id">
														<span>#1084598423154</span>
													</td>
													<td className="date-id">
														<span>04-12-21</span>
													</td>
													<td className="reject-id">
														<span className="Confirm">Confirm</span>
													</td>
													<td className="order-id">
														<span className="paid">
															Paid <i className="fa fa-check-circle"></i>
														</span>
													</td>
													<td className="total">
														<span>$590.00</span>
													</td>
													<td className="btns">
														<button onClick={orderdetail} className="btn">
															view Details
														</button>
													</td>
												</tr>
												<tr>
													<td className="order-id">
														<span>#1084598423154</span>
													</td>
													<td className="date-id">
														<span>04-12-21</span>
													</td>
													<td className="reject-id">
														<span className="Confirm">Confirm</span>
													</td>
													<td className="order-id">
														<span className="paid">
															Paid <i className="fa fa-check-circle"></i>
														</span>
													</td>
													<td className="total">
														<span>$590.00</span>
													</td>
													<td className="btns">
														<button className="btn">view Details</button>
													</td>
												</tr>
												<tr>
													<td className="order-id">
														<span>#1084598423154</span>
													</td>
													<td className="date-id">
														<span>04-12-21</span>
													</td>
													<td className="reject-id">
														<span className="Confirm">Confirm</span>
													</td>
													<td className="order-id">
														<span className="paid">
															Paid <i className="fa fa-check-circle"></i>
														</span>
													</td>
													<td className="total">
														<span>$590.00</span>
													</td>
													<td className="btns">
														<button className="btn">view Details</button>
													</td>
												</tr>
												<tr>
													<td className="order-id">
														<span>#1084598423154</span>
													</td>
													<td className="date-id">
														<span>04-12-21</span>
													</td>
													<td className="reject-id">
														<span className="Confirm">Confirm</span>
													</td>
													<td className="order-id">
														<span className="paid">
															Paid <i className="fa fa-check-circle"></i>
														</span>
													</td>
													<td className="total">
														<span>$590.00</span>
													</td>
													<td className="btns">
														<button className="btn">view Details</button>
													</td>
												</tr>
											</tbody>
										</table>
									</div>
								</div>
								<div className="paginations-wrapper">
									<ul>
										<li className="controls">
											<button className="back">
												<i className="fa fa-angle-left"></i>
											</button>
										</li>
										<li className="number">
											<button className="num">1</button>
										</li>
										<li className="number active">
											<button className="num">2</button>
										</li>
										<li className="number">
											<button className="num">3</button>
										</li>
										<li className="number">
											<button className="num">4</button>
										</li>
										<li className="controls">
											<button className="forward">
												<i className="fa fa-angle-right"></i>
											</button>
										</li>
									</ul>
								</div>
							</div>
							{/* return payment ends here */}
						</div>
					</div>
				</div>
			</section>
			{/* My adresses ends here */}
			<Footer />
		</>
	);
};

export default Myorder;
